import axios from 'axios'

const http = axios.create({
	baseURL: 'https://zhicheng.gsjtpxzx.com/api',
	// baseURL: 'http://8.130.99.86:82/api',
	timeout: 10000
})

// 请求拦截器
http.interceptors.request.use(
	config => {
		// 判断是否需要token
		if (config.headers.requireAuth) {
			const token = JSON.parse(sessionStorage.getItem('token'))

			if (token) {
				config.headers.token = `${token}`
			} else {
				sessionStorage.clear()
				// 重定向到根路径
				window.location.href = '/'
			}
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器              
http.interceptors.response.use(
	response => {
		return response.data
	},
	error => {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					sessionStorage.clear()
					// 401 未授权，跳转到登录页面
					window.location.href = '/'
					break
				default:
					// 其他错误提示
					alert(error.response.data.message || '请求失败')
			}
		}
		return Promise.reject(error)
	}
)

export default http